import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';

@ComponentDecorator({
  props: {
    text: String,
    subText: String,
  },
})

export default class CubeInfoBlock extends Vue {
}
